<template>
  <otif-modal
    ref="confirm-delete-row"
    title="Remove Documents"
    :value="value"
    @input="$emit('input', $event)"
  >
    <p>
      Are you sure you want to remove following file from the current documents
      batch ( along with unsaved Data ):
      <span
        v-for="fileName in deletefiles"
      >
        <br />
        <b>{{ fileName }}</b>
      </span>
      <strong>&nbsp;?</strong>
    </p>
    <template slot="footer">
      <otif-button class="OTSecondary" @click.native="no">No</otif-button>
      <otif-button class="OTPrimary" @click.native="yes">Yes</otif-button>
    </template>
  </otif-modal>
</template>

<script>
import { EventBus } from "@mtm-studio/components/src/lib/eventBus.js";
export default {
  data() {
    return {
      Documents: null
    };
  },
  props: ["value", "rows", "row", "rowNumber", "deletefiles"],
  methods: {
    no() {
      this.$emit("input", false);
    },

    async yes() {
      this.$snotify.info("Deleting Documents", {
        timeout: 0
      });
      if (this.deletefiles.length > 1) {        
        EventBus.$emit("deleteAllDocuments", this.deletefiles);
      } else {       
      EventBus.$emit(
        "deleteDocument",
        this.deletefiles,
        this.rows,
        this.rowNumber
      );
      }
      this.$snotify.clear();
      this.$snotify.success("Removed document(s)");
      this.$emit("deleted");
      this.$emit("input", false);
    }
  }
};
</script>
